module.exports = __webpack_public_path__ + "img/precio.ea672e3b.svg";